import { Expose } from 'class-transformer';
import ClusterHotelsModel from '@/modules/cluster/models/cluster.model';
import ClusterInsightsDocumentModel from './cluster-insights-document.model';

export default class ClusterInsightsModel extends ClusterHotelsModel {
    @Expose()
    compsetMain?: ClusterInsightsDocumentModel;
}
